import config from '../apis/config.js';
//处理文件图标
export function fileIcon(resourceType, fileNameOrUrl) {
	// 定义图标的映射
	const icons = {
		0: require('@/assets/img/i134.png'), // 文件夹
		1: config.imgRoot + fileNameOrUrl + '?x-oss-process=video/snapshot,t_1000,m_fast,w_800', // 视频
		2: config.imgRoot + fileNameOrUrl, // 图片
		3: getDocumentIcon(config.imgRoot + fileNameOrUrl), // 文档
		4: require('@/assets/img/i135.png'), // 音频
		5: require('@/assets/img/i136.png'), // 链接
		6: require('@/assets/img/i200.png') // 笔记
	};

	return icons[resourceType] || ''; // 默认图标
}

function getDocumentIcon(fileName) {
	// 判断文件扩展名以返回相应的文档图标
	const extension = fileName.split('.').pop().toLowerCase();
	switch (extension) {
		case 'xls':
		case 'xlsx':
			return require('@/assets/img/i201.png'); // Excel 图标
		case 'ppt':
		case 'pptx':
			return require('@/assets/img/i199.png'); // PPT 图标
		case 'doc':
		case 'docx':
			return require('@/assets/img/i108.png'); // Word 图标
		case 'pdf':
			return require('@/assets/img/i137.png'); // PDF 图标
		default:
			return require('@/assets/img/i200.png'); // 默认文档图标
	}
}